var map = {
	"./AD.svg": "MMv1",
	"./AE.svg": "cOe1",
	"./AF.svg": "wOB8",
	"./AG.svg": "kmXw",
	"./AI.svg": "dVR/",
	"./AL.svg": "iL1Q",
	"./AM.svg": "upkC",
	"./AO.svg": "aX9a",
	"./AR.svg": "U1hd",
	"./AS.svg": "QEKa",
	"./AT.svg": "nDTo",
	"./AU.svg": "VY8Z",
	"./AW.svg": "AZML",
	"./AX.svg": "wRH3",
	"./AZ.svg": "nUpl",
	"./BA.svg": "SF/t",
	"./BB.svg": "XSBQ",
	"./BD.svg": "J+Gc",
	"./BE.svg": "kce8",
	"./BF.svg": "0NfW",
	"./BG.svg": "SqZ8",
	"./BH.svg": "n6fu",
	"./BI.svg": "PPld",
	"./BJ.svg": "NYD0",
	"./BL.svg": "Y7R/",
	"./BM.svg": "P9Fo",
	"./BN.svg": "T+UH",
	"./BO.svg": "7mSs",
	"./BR.svg": "Uocv",
	"./BS.svg": "7NX6",
	"./BT.svg": "MWjD",
	"./BV.svg": "4BYk",
	"./BW.svg": "91zh",
	"./BY.svg": "mZm+",
	"./BZ.svg": "tXnu",
	"./CA.svg": "se7I",
	"./CC.svg": "Xf2d",
	"./CD.svg": "ogxS",
	"./CF.svg": "ccvu",
	"./CG.svg": "zKu7",
	"./CH.svg": "uOoq",
	"./CI.svg": "HIIy",
	"./CK.svg": "s7/r",
	"./CL.svg": "NBoL",
	"./CM.svg": "WYbN",
	"./CN.svg": "d6Ym",
	"./CO.svg": "u5FQ",
	"./CR.svg": "/e1p",
	"./CU.svg": "TROa",
	"./CV.svg": "qhKH",
	"./CW.svg": "DnG2",
	"./CX.svg": "n+Tb",
	"./CY.svg": "GESN",
	"./CZ.svg": "vtNa",
	"./DE.svg": "1+jb",
	"./DJ.svg": "Dv3c",
	"./DK.svg": "W0CC",
	"./DM.svg": "ND3w",
	"./DO.svg": "/WVm",
	"./DZ.svg": "Fmlp",
	"./EC.svg": "pPnz",
	"./EE.svg": "f2F6",
	"./EG.svg": "C3h+",
	"./ER.svg": "CpyJ",
	"./ES.svg": "K2ZY",
	"./ET.svg": "v8G9",
	"./EU.svg": "uU8P",
	"./FI.svg": "+EED",
	"./FJ.svg": "mbqa",
	"./FK.svg": "LVYh",
	"./FM.svg": "wi8u",
	"./FO.svg": "ypHJ",
	"./FR.svg": "XFmu",
	"./GA.svg": "fqqb",
	"./GB-ENG.svg": "GEyK",
	"./GB-NIR.svg": "2VVG",
	"./GB-SCT.svg": "nTQh",
	"./GB-WLS.svg": "UFOd",
	"./GB-ZET.svg": "WJnq",
	"./GB.svg": "+CMp",
	"./GD.svg": "b3VJ",
	"./GE.svg": "phcu",
	"./GF.svg": "2gk2",
	"./GG.svg": "azWn",
	"./GH.svg": "Whe8",
	"./GI.svg": "kKsu",
	"./GL.svg": "dT4q",
	"./GM.svg": "joXL",
	"./GN.svg": "pZyC",
	"./GP.svg": "Vn+r",
	"./GQ.svg": "fH+x",
	"./GR.svg": "vXKk",
	"./GS.svg": "amR2",
	"./GT.svg": "W6Iy",
	"./GU.svg": "KHw9",
	"./GW.svg": "MNVd",
	"./GY.svg": "rXKx",
	"./HK.svg": "lk2/",
	"./HM.svg": "YLBV",
	"./HN.svg": "NDhE",
	"./HR.svg": "1EJd",
	"./HT.svg": "3y25",
	"./HU.svg": "eLYb",
	"./ID.svg": "qJnw",
	"./IE.svg": "2zgw",
	"./IL.svg": "yYnu",
	"./IM.svg": "oVDZ",
	"./IN.svg": "8J+0",
	"./IO.svg": "B+wl",
	"./IQ.svg": "nK93",
	"./IR.svg": "AXdl",
	"./IS.svg": "7NwK",
	"./IT.svg": "NWOt",
	"./JE.svg": "VTnN",
	"./JM.svg": "1U12",
	"./JO.svg": "eg+L",
	"./JP.svg": "XOxr",
	"./KE.svg": "Rtcn",
	"./KG.svg": "ED59",
	"./KH.svg": "853R",
	"./KI.svg": "n1tF",
	"./KM.svg": "7bNE",
	"./KN.svg": "pFti",
	"./KP.svg": "ZRxJ",
	"./KR.svg": "pdvs",
	"./KW.svg": "yhs6",
	"./KY.svg": "iwtG",
	"./KZ.svg": "fI0B",
	"./LA.svg": "TLlV",
	"./LB.svg": "vRVh",
	"./LC.svg": "0EKn",
	"./LGBT.svg": "CZem",
	"./LI.svg": "AqMp",
	"./LK.svg": "bzfS",
	"./LR.svg": "bziC",
	"./LS.svg": "BqBA",
	"./LT.svg": "7gN1",
	"./LU.svg": "eIc2",
	"./LV.svg": "kIly",
	"./LY.svg": "gmqB",
	"./MA.svg": "gCNj",
	"./MC.svg": "Z2Px",
	"./MD.svg": "hT+/",
	"./ME.svg": "hHxR",
	"./MG.svg": "6hOU",
	"./MH.svg": "PFpk",
	"./MK.svg": "mGEn",
	"./ML.svg": "o42T",
	"./MM.svg": "NShS",
	"./MN.svg": "oNrs",
	"./MO.svg": "Mx4f",
	"./MP.svg": "s5SW",
	"./MQ.svg": "XNER",
	"./MR.svg": "JorU",
	"./MS.svg": "49CT",
	"./MT.svg": "ijLx",
	"./MU.svg": "Iqum",
	"./MV.svg": "wO5F",
	"./MW.svg": "utL6",
	"./MX.svg": "4323",
	"./MY.svg": "rGw5",
	"./MZ.svg": "eddg",
	"./NA.svg": "5UW0",
	"./NC.svg": "L4EI",
	"./NE.svg": "hokk",
	"./NF.svg": "o5/R",
	"./NG.svg": "NuiH",
	"./NI.svg": "lCvN",
	"./NL.svg": "6mFK",
	"./NO.svg": "Zrwj",
	"./NP.svg": "cu4k",
	"./NR.svg": "ZexQ",
	"./NU.svg": "/iFO",
	"./NZ.svg": "ymp2",
	"./OM.svg": "Z6Fn",
	"./PA.svg": "eGP/",
	"./PE.svg": "jLKQ",
	"./PF.svg": "YgzI",
	"./PG.svg": "5hbt",
	"./PH.svg": "9tO6",
	"./PK.svg": "ZXvj",
	"./PL.svg": "iMYx",
	"./PM.svg": "/Htx",
	"./PN.svg": "lKtd",
	"./PR.svg": "A8EE",
	"./PS.svg": "eCmc",
	"./PT.svg": "Vc1j",
	"./PW.svg": "rrKU",
	"./PY.svg": "9qeh",
	"./QA.svg": "AaeZ",
	"./RE.svg": "HzG2",
	"./RO.svg": "7noj",
	"./RS.svg": "tVmb",
	"./RU.svg": "t2Jb",
	"./RW.svg": "J+jE",
	"./SA.svg": "xKG4",
	"./SAMI.svg": "b74q",
	"./SB.svg": "+73u",
	"./SC.svg": "WHuZ",
	"./SD.svg": "fizj",
	"./SE-JAM.svg": "2pbi",
	"./SE-SKA.svg": "tpkO",
	"./SE-VAS.svg": "/0WK",
	"./SE.svg": "T+CG",
	"./SEFI.svg": "C6UR",
	"./SG.svg": "4mLE",
	"./SI.svg": "toJH",
	"./SJ.svg": "RZYX",
	"./SK.svg": "dGh9",
	"./SL.svg": "BkJg",
	"./SM.svg": "Lha/",
	"./SN.svg": "mNNN",
	"./SO.svg": "UwWW",
	"./SR.svg": "KYT4",
	"./SS.svg": "ssXP",
	"./ST.svg": "d4Mg",
	"./SV.svg": "J0DB",
	"./SX.svg": "VK76",
	"./SY.svg": "Ezb4",
	"./SZ.svg": "4hf8",
	"./TC.svg": "7LuT",
	"./TD.svg": "KFCT",
	"./TF.svg": "jp+a",
	"./TG.svg": "qNpr",
	"./TH.svg": "DIVb",
	"./TJ.svg": "jXEi",
	"./TK.svg": "UYw9",
	"./TL.svg": "6XHY",
	"./TM.svg": "26sO",
	"./TN.svg": "N/IZ",
	"./TO.svg": "eMQg",
	"./TORN.svg": "MAvv",
	"./TR.svg": "1kus",
	"./TT.svg": "xA+r",
	"./TV.svg": "N5Eg",
	"./TW.svg": "Fqkr",
	"./TZ.svg": "croe",
	"./UA.svg": "6Fh7",
	"./UG.svg": "Iw5E",
	"./UM.svg": "6agN",
	"./US-CA.svg": "w81o",
	"./US.svg": "mZzj",
	"./UY.svg": "UosC",
	"./UZ.svg": "r37R",
	"./VA.svg": "2pJ7",
	"./VC.svg": "tuVf",
	"./VE.svg": "P6Jn",
	"./VG.svg": "xmqe",
	"./VI.svg": "GUUl",
	"./VN.svg": "Lb7R",
	"./VU.svg": "i26V",
	"./WF.svg": "7vYA",
	"./WS.svg": "NcPb",
	"./WW-AFR.svg": "12au",
	"./WW-ASI.svg": "5bMr",
	"./WW-AUS.svg": "8Co0",
	"./WW-EUR.svg": "Jc8+",
	"./WW-NAM.svg": "tQcU",
	"./WW-SAM.svg": "iRSW",
	"./WW.svg": "ASSR",
	"./XK.svg": "i0hu",
	"./YE.svg": "o3tX",
	"./YT.svg": "ypMw",
	"./ZA.svg": "OU4Y",
	"./ZM.svg": "HHg+",
	"./ZW.svg": "wvM8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l76G";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets ^\.\/.*\.svg$
// module id = l76G
// module chunks = 0